export function generateBranch(folderId: string | number, foldersList: Folder[]): Folder | null {
    const rootFolder = foldersList.find((f) => f.id === folderId);

    if (!rootFolder) {
        // Folder with the specified ID not found
        return null;
    }

    const children = foldersList.filter((f) => f.parent_id === folderId);

    if (children.length === 0) {
        // If the folder has no children, return the folder itself as the tree node
        return { ...rootFolder, children: [] };
    }

    // Recursively generate the tree for each child folder
    const tree: Folder = { ...rootFolder, children: [] };

    // eslint-disable-next-line no-restricted-syntax
    for (const child of children) {
        const childTree = generateBranch(child.id, foldersList);

        tree.children.push(childTree as Folder);
    }

    return tree;
}

// Function to calculate the maximum depth of nested folders in a tree
export function calculateMaxDepth(treeNode: Folder | null): number {
    if (!treeNode || !treeNode.children || treeNode.children.length === 0) {
        // If the node has no children, it is at depth 1
        return 0;
    }

    // Recursively calculate the maximum depth among its children
    const childrenDepths = treeNode.children.map((child) => calculateMaxDepth(child));

    // Find the maximum depth among the children and return the maximum depth plus 1
    return Math.max(...childrenDepths) + 1;
}
